import { URLQueries } from './url_query'

export const getChannelId = () => {
  const disableDCHN = URLQueries.getQuery('source_disable_dchn')
  const channelId = URLQueries.getQuery('channelId')
  const dchn = URLQueries.getQuery('dchn')
  if (disableDCHN) return channelId || '00000'
  return dchn || channelId || '00000'
}
